import type { CustomerGroupRequest, CustomerGroupResponse, CustomerGroupsResponse } from '@/types';
import type { AxiosInstance, AxiosResponse } from 'axios';

class CustomerGroupService {
    private readonly apiService;

    constructor(apiService: AxiosInstance) {
        this.apiService = apiService;
    }

    getPath(id?: string) {
        return id ? `/api/customer-groups/${id}` : '/api/customer-groups';
    }

    index(): Promise<AxiosResponse<CustomerGroupsResponse>> {
        return this.apiService.get(this.getPath());
    }

    show(id: string): Promise<AxiosResponse<CustomerGroupResponse>> {
        return this.apiService.get(this.getPath(id));
    }

    store(request: CustomerGroupRequest): Promise<AxiosResponse<CustomerGroupResponse>> {
        return this.apiService.post(this.getPath(), request);
    }

    update(id: string, request: CustomerGroupRequest): Promise<AxiosResponse<CustomerGroupResponse>> {
        return this.apiService.put(this.getPath(id), request);
    }

    delete(id: string): Promise<AxiosResponse<void>> {
        return this.apiService.delete(this.getPath(id));
    }

    syncCustomerGroups(customerId: string, groupIds: string[]): Promise<AxiosResponse<{ data: unknown }>> {
        return this.apiService.patch(`/api/customers/${customerId}/groups`, { group_ids: groupIds });
    }

    attachCustomers(groupId: string, customerIds: string[]): Promise<AxiosResponse<void>> {
        return this.apiService.post(`/api/customer-groups/${groupId}/customers`, { customer_ids: customerIds });
    }

    detachCustomers(groupId: string, customerIds: string[]): Promise<AxiosResponse<void>> {
        return this.apiService.delete(`/api/customer-groups/${groupId}/customers`, {
            data: { customer_ids: customerIds },
        });
    }
}

export default CustomerGroupService;
